import { render, staticRenderFns } from "./caseInformation.vue?vue&type=template&id=1c127515&scoped=true"
import script from "./caseInformation.vue?vue&type=script&lang=js"
export * from "./caseInformation.vue?vue&type=script&lang=js"
import style0 from "./caseInformation.vue?vue&type=style&index=0&id=1c127515&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c127515",
  null
  
)

export default component.exports